import { SVGProps } from 'react'

export const CallEndIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect width="40" height="40" rx="20" fill="#D92D20" />
    <g clipPath="url(#clip0_16083_6811)">
      <path
        d="M21.5372 15.5C22.2698 15.6429 22.943 16.0012 23.4708 16.529C23.9986 17.0567 24.3568 17.7299 24.4997 18.4625M21.5372 12.5C23.0592 12.6691 24.4784 13.3506 25.5619 14.4328C26.6454 15.5149 27.3288 16.9333 27.4997 18.455M18.67 21.3973C17.7688 20.4961 17.0572 19.4771 16.5352 18.3899C16.4903 18.2964 16.4679 18.2496 16.4506 18.1905C16.3893 17.9802 16.4333 17.722 16.5609 17.5439C16.5967 17.4938 16.6396 17.451 16.7253 17.3652C16.9875 17.103 17.1186 16.9719 17.2044 16.8401C17.5276 16.3429 17.5276 15.702 17.2044 15.2048C17.1186 15.073 16.9875 14.9419 16.7253 14.6797L16.5792 14.5335C16.1806 14.1349 15.9813 13.9357 15.7673 13.8274C15.3416 13.6121 14.8389 13.6121 14.4132 13.8274C14.1992 13.9357 13.9999 14.1349 13.6013 14.5335L13.4831 14.6518C13.0859 15.049 12.8873 15.2476 12.7356 15.5176C12.5673 15.8172 12.4462 16.2826 12.4473 16.6263C12.4482 16.936 12.5083 17.1476 12.6284 17.571C13.2742 19.846 14.4925 21.9928 16.2835 23.7838C18.0745 25.5748 20.2213 26.7931 22.4963 27.4389C22.9196 27.559 23.1313 27.6191 23.441 27.62C23.7847 27.621 24.25 27.5 24.5497 27.3317C24.8197 27.18 25.0183 26.9814 25.4155 26.5842L25.5337 26.466C25.9323 26.0674 26.1316 25.8681 26.2399 25.6541C26.4552 25.2284 26.4552 24.7257 26.2399 24.3C26.1316 24.086 25.9323 23.8867 25.5337 23.4881L25.3876 23.3419C25.1254 23.0797 24.9943 22.9486 24.8625 22.8629C24.3653 22.5397 23.7244 22.5397 23.2272 22.8629C23.0954 22.9486 22.9643 23.0797 22.702 23.3419C22.6163 23.4277 22.5734 23.4706 22.5233 23.5064C22.3453 23.6339 22.0871 23.678 21.8768 23.6167C21.8176 23.5994 21.7709 23.577 21.6774 23.5321C20.5901 23.0101 19.5712 22.2985 18.67 21.3973Z"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_16083_6811">
        <rect
          width="18"
          height="18"
          fill="white"
          transform="translate(11 11)"
        />
      </clipPath>
    </defs>
  </svg>
)
